import React from 'react';
import {Route, Routes} from "react-router-dom";
import Setting from "./index";
import TimeKeepingSettingRouter from "./timekeeping/Router";

const SettingRouter = props => {

    return (
        <Routes>
            <Route path="/">
                <Route index element={<Setting/>}/>
                <Route path="timekeeping/*" element={<TimeKeepingSettingRouter/>}/>
            </Route>

        </Routes>
    );
};

SettingRouter.propTypes = {};

export default SettingRouter;
